import { ReactComponent as NewInBoostIcon } from "assets/New_in_boost_icon.svg";
import Typography from "components/common/Typography";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { getUserHltId } from "utils/CommonFunctions";
import { hasBoostBuzz, resolveInncodesByUserType } from "./BuzzHelper";
import "./index.scss";
import { setIsPostBoostBuzzClick, setReleaseHighlightDialog, setReleaseNote } from "./ReleaseHighlights.slice";

const ReleaseBanner = (props: any) => {
  const dispatch = useAppDispatch();

  const ReleaseHighlights = useAppSelector((state) => state.ReleaseHighlights);
  const inncode = useAppSelector((state: any) => state.app.innCode);
  const userInncodes = resolveInncodesByUserType(inncode);
  const isUserHaveBuzz = hasBoostBuzz(ReleaseHighlights, userInncodes);

  // Displays the corresponding cards based on the provided code.
  // If it is a corp, it will return all cards.
  const findCardsByTarget = (input: any, items: any) => {
    if (input === DEFAULT_CORP_INNCODE) return items;
    const searchValues = Array.isArray(input) ? input : [input];
    return items.filter((item: any) => searchValues.some((val) => item?.targets?.includes(val)));
  };

  const onBuzzClick = async () => {
    const allCards = ReleaseHighlights?.[getUserHltId()]?.allCards;
    const cardsByInncodes = findCardsByTarget(userInncodes, allCards);
    dispatch(setReleaseNote({ payload: cardsByInncodes, inncode: getUserHltId() }));
    dispatch(setReleaseHighlightDialog(true));
    dispatch(setIsPostBoostBuzzClick(false));
  };

  return isUserHaveBuzz ? (
    <div className="banner-parent-container">
      <button className={`banner-container ${props.class}`} onClick={onBuzzClick}>
        <Typography color={tokens.Text.General.Secondary} showBold>
          BOOST Buzz{" "}
        </Typography>
        <div className="banner-container-icon">
          <Typography className="banner-container-icon-text" color={tokens.Text.General.PrimaryBody} variant={"body2"}>
            Click here to stay in the loop with what's new and noteworthy in BOOST
          </Typography>
          <NewInBoostIcon />
        </div>
      </button>
    </div>
  ) : (
    <></>
  );
};

export default ReleaseBanner;
